(() => {
  const selector = "video[data-gbof-factory-video]";
  const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
  const saveData = navigator.connection?.saveData === true;

  function loadVideo(video) {
    if (video.dataset.gbofFactoryLoaded === "true" || reducedMotion || saveData) return;
    const desktop = window.matchMedia?.("(min-width: 750px)")?.matches;
    const suffix = desktop ? "Desktop" : "Mobile";
    const webm = video.dataset[`webm${suffix}`];
    const mp4 = video.dataset[`mp4${suffix}`];
    if (!webm || !mp4) return;

    const webmSource = document.createElement("source");
    webmSource.type = "video/webm";
    webmSource.src = webm;
    const mp4Source = document.createElement("source");
    mp4Source.type = "video/mp4";
    mp4Source.src = mp4;
    video.append(webmSource, mp4Source);
    video.dataset.gbofFactoryLoaded = "true";
    video.addEventListener("playing", () => video.classList.add("is-gbof-factory-playing"), { once: true });
    video.load();
    video.play().catch(() => {});
  }

  function pauseOutsideViewport(video) {
    if (video.dataset.gbofFactoryLoaded !== "true") return;
    video.pause();
  }

  function resumeInViewport(video) {
    if (video.dataset.gbofFactoryLoaded !== "true" || document.hidden) return;
    video.play().catch(() => {});
  }

  function initialise() {
    const videos = [...document.querySelectorAll(selector)];
    if (!videos.length || reducedMotion || saveData) return;

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        const video = entry.target;
        if (entry.isIntersecting) {
          loadVideo(video);
          resumeInViewport(video);
        } else {
          pauseOutsideViewport(video);
        }
      }
    }, { rootMargin: "250px 0px", threshold: 0.01 });

    for (const video of videos) observer.observe(video);
    document.addEventListener("visibilitychange", () => {
      for (const video of videos) {
        if (document.hidden) pauseOutsideViewport(video);
        else if (video.getBoundingClientRect().top < window.innerHeight + 250 && video.getBoundingClientRect().bottom > -250) resumeInViewport(video);
      }
    }, { passive: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialise, { once: true });
  else initialise();
})();
